import clsx from 'classnames';
import moment from 'moment';

import { Stack, Text } from '@mantine/core';
import type { MessageProps } from '../types/message.types';

import classes from './Message.module.css';

export function ChatMessage({ content, timestamp, sender }: MessageProps) {
  return (
    <Stack gap="0">
      <Text
        className={clsx(classes.message, {
          [classes.agent as string]: sender === 'agent',
          [classes.customer as string]: sender === 'customer',
          [classes.system as string]: sender === 'system',
        })}
      >
        {content}
      </Text>
      <Text className={classes.timestamp}>
        {moment(timestamp).format('h:mm A')}
      </Text>
    </Stack>
  );
}
